module.exports = __webpack_public_path__ + "img/ball2_xn.1fa27b22.png";